import CircleChart from './component'

export default CircleChart
